<div class="container-fluid">
  <mat-card class="tile-creator" *ngIf="currentPlugin == 'LAVA.XML'">
    <div class="card-content row">
      <div class="col-md-6 col-sm-12">
        <div class="row">
          <div class="col-10">
            <mat-card-title class="task-creator-tile-title">{{ block?.tileItem?.file?.name }}</mat-card-title>
            <mat-card-subtitle *ngIf="block?.tileItem?.bytes">
              <span>{{ block?.tileItem?.bytes }}</span>
              <span> | </span>
              <span>{{ getTime(block?.tileItem?.duration) }}</span>
            </mat-card-subtitle>
          </div>
          <div class="col-2">
          </div>
        </div>
        <div class="row">
          <div class="col-md-6 col-sm-12 col-xs-12">
            <dx-select-box class="item-select-box"
                           [label]="'From Microphone'"
                           [items]="fromMenuItems"
                           [value]="block.menuItems[0]"
                           [searchMode]="searchModeOption"
                           [searchExpr]="searchExprOption"
                           [searchTimeout]="searchTimeoutOption"
                           [minSearchLength]="minSearchLengthOption"
                           [searchEnabled]="true"
                           [showDataBeforeSearch]="showDataBeforeSearchOption"
                           displayExpr="caption"
                           (onInitialized)="onFromDropdownInitialized($event)"
                           (onValueChanged)="onFromValueChanged($event)">
            </dx-select-box>
          </div>
          <div class="col-md-6 col-sm-12 col-xs-12">
            <dx-select-box class="item-select-box"
                           [label]="'To Microphone'"
                           [items]="toMenuItems"
                           [value]="block.menuItems[1]"
                           [searchMode]="searchModeOption"
                           [searchExpr]="searchExprOption"
                           [searchTimeout]="searchTimeoutOption"
                           [minSearchLength]="minSearchLengthOption"
                           [searchEnabled]="true"
                           displayExpr="caption"
                           (onInitialized)="onToDropdownInitialized($event)"
                           (onValueChanged)="onToValueChanged($event)">
            </dx-select-box>
          </div>
        </div>
      </div>
      <div class="col-md-6 col-sm-12">
        <div class="row">
          <div class="tile-creator-image-container" (click)="openInfoBlock()">
            <img class="tile-creator-image" alt="" [src]="block.menuItems[1].blobUrl" />
            <fa-icon [icon]="faCircleInfo"></fa-icon>
          </div>
          <div style="width:80%">
            <div class="waveform" id="{{waveformId}}"></div>
            <div id="{{timelineId}}"></div>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <mat-progress-bar class="tile-creator-progress-bar" mode="determinate" [value]="block?.tileItem?.progress"></mat-progress-bar>
    </div>
    <mat-card-actions class="tile-creator-actions" align="end">
      <button mat-raised-button color="primary" (click)="preview()">
        <fa-icon [icon]="faRocket"></fa-icon>
        <span class="task-creator-tile-action-caption">
          Preview
        </span>
      </button>
      <button mat-raised-button color="primary" (click)="zoomIn()">
        <fa-icon [icon]="faMagnifyingGlassPlus"></fa-icon>
        <span class="task-creator-tile-action-caption">
          Zoom In
        </span>
      </button>
      <button mat-raised-button color="primary" (click)="zoomOut()">
        <fa-icon [icon]="faMagnifyingGlassMinus"></fa-icon>
        <span class="task-creator-tile-action-caption">
          Zoom Out
        </span>
      </button>
      <button mat-raised-button color="primary" (click)="playPause()">
        <div *ngIf="!waveInstance?.isPlaying()">
          <fa-icon [icon]="faPlay"></fa-icon>
          <span class="task-creator-tile-action-caption">
            Play
          </span>
        </div>
        <div *ngIf="waveInstance?.isPlaying()">
          <fa-icon [icon]="faPause"></fa-icon>
          <span class="task-creator-tile-action-caption">
            Pause
          </span>
        </div>
      </button>
      <button mat-raised-button color="primary" (click)="sendCopyBlockSettings(block)">
        <fa-icon [icon]="faCopy"></fa-icon>
        <span class="task-creator-tile-action-caption">
          Copy Mics
        </span>
      </button>
      <button mat-raised-button color="primary" (click)="deleteBlockRequest($event, block)">
        <fa-icon [icon]="faTrashCan"></fa-icon>
        <span class="task-creator-tile-action-caption">
          Remove
        </span>
      </button>
    </mat-card-actions>
  </mat-card>


  <mat-card class="tile-creator" *ngIf="currentPlugin == 'Inference'">
    <div class="card-content row">
      <div class="col-md-6 col-sm-12">
        <div class="row">
          <div class="col-10">
            <mat-card-title class="task-creator-tile-title">{{ block?.tileItem?.file?.name }}</mat-card-title>
            <mat-card-subtitle *ngIf="block?.tileItem?.bytes">
              <span>{{ block?.tileItem?.bytes }}</span>
              <span> | </span>
              <span>{{ getTime(block?.tileItem?.duration) }}</span>
            </mat-card-subtitle>
          </div>
          <div class="col-2">
          </div>
        </div>
        <div class="row">
          <div class="col-md-6 col-sm-12 col-xs-12">
            <dx-select-box class="item-select-box"
                           [label]="'To Voice'"
                           [items]="toMenuItems"
                           [value]="block.menuItems[0]"
                           [searchMode]="searchModeOption"
                           [searchExpr]="searchExprOption"
                           [searchTimeout]="searchTimeoutOption"
                           [minSearchLength]="minSearchLengthOption"
                           [searchEnabled]="true"
                           displayExpr="caption"
                           (onInitialized)="onToDropdownInitialized($event)"
                           (onValueChanged)="onToValueChanged($event)">
            </dx-select-box>
          </div>
        </div>
      </div>
      <div class="col-md-6 col-sm-12">
        <div class="row">
          <!--<div class="tile-creator-image-container" (click)="openInfoBlock()">
            <img class="tile-creator-image" alt="" [src]="block.menuItems[1].blobUrl" />
            <fa-icon [icon]="faCircleInfo"></fa-icon>
          </div>-->
          <div style="width:80%">
            <div class="waveform" id="{{waveformId}}"></div>
            <div id="{{timelineId}}"></div>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <mat-progress-bar class="tile-creator-progress-bar" mode="determinate" [value]="block?.tileItem?.progress"></mat-progress-bar>
    </div>
    <mat-card-actions class="tile-creator-actions" align="end">
      <button mat-raised-button color="primary" (click)="preview()">
        <fa-icon [icon]="faRocket"></fa-icon>
        <span class="task-creator-tile-action-caption">
          Preview
        </span>
      </button>
      <button mat-raised-button color="primary" (click)="zoomIn()">
        <fa-icon [icon]="faMagnifyingGlassPlus"></fa-icon>
        <span class="task-creator-tile-action-caption">
          Zoom In
        </span>
      </button>
      <button mat-raised-button color="primary" (click)="zoomOut()">
        <fa-icon [icon]="faMagnifyingGlassMinus"></fa-icon>
        <span class="task-creator-tile-action-caption">
          Zoom Out
        </span>
      </button>
      <button mat-raised-button color="primary" (click)="playPause()">
        <div *ngIf="!waveInstance?.isPlaying()">
          <fa-icon [icon]="faPlay"></fa-icon>
          <span class="task-creator-tile-action-caption">
            Play
          </span>
        </div>
        <div *ngIf="waveInstance?.isPlaying()">
          <fa-icon [icon]="faPause"></fa-icon>
          <span class="task-creator-tile-action-caption">
            Pause
          </span>
        </div>
      </button>
      <button mat-raised-button color="primary" (click)="sendCopyBlockSettings(block)">
        <fa-icon [icon]="faCopy"></fa-icon>
        <span class="task-creator-tile-action-caption">
          Copy Mics
        </span>
      </button>
      <button mat-raised-button color="primary" (click)="deleteBlockRequest($event, block)">
        <fa-icon [icon]="faTrashCan"></fa-icon>
        <span class="task-creator-tile-action-caption">
          Remove
        </span>
      </button>
    </mat-card-actions>
  </mat-card>
</div>

<ngx-ui-loader [loaderId]="loaderId"></ngx-ui-loader>
